'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rethrowCommonErrors = undefined;

var _rethrowIfOneOf = require('./rethrow-if-one-of');

/**
 * Rethrows common errors like SyntaxError or ReferenceError.
 * @param {function} fn, a promise
 * @example
 * import { rethrowCommonErrors } from 'promise-frites';
 *
 * Promise.resolve()
 *   .then(() => x) // ReferenceError: x is not defined
 *   .catch(rethrowCommonErrors(notifyUser))
 *   .catch(rethrowCommonErrors(logError));
 */
var rethrowCommonErrors = exports.rethrowCommonErrors = (0, _rethrowIfOneOf.rethrowIfOneOf)(ReferenceError, TypeError, EvalError, RangeError, SyntaxError, URIError);